module.exports = __webpack_public_path__ + "img/nav-video.2c722a1d.png";